import React, { useState, useMemo } from 'react';
import * as styles from './RackRateInputs.module.scss';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import { loanPurpose, closingCostType } from '@enums';

export default function RackRateInputs({
  defaultLoanPurpose,
  rackRateLoanPurpose,
  rackRateLoanType,
  setRackRateLoanPurpose,
  setRackRateLoanType
}) {
  const loanPurposeOptions = [
    { label: 'Refinance', value: loanPurpose.REFINANCE },
    { label: 'Purchase', value: loanPurpose.PURCHASE }
  ];

  const loanTypeOptions = [
    { label: 'No closing costs', value: closingCostType.NCC },
    { label: 'Points & Fees', value: closingCostType.POINTS }
  ];

  if (defaultLoanPurpose === loanPurpose.PURCHASE) {
    loanPurposeOptions.reverse();
  }

  return (
    <div className={styles.wrapper}>
      <Toggle
        key="loan-purpose"
        value={rackRateLoanPurpose}
        label="Select a loan purpose"
        maxWidth={380}
        options={loanPurposeOptions}
        setValue={setRackRateLoanPurpose}
      />
      <Toggle
        key="loan-type"
        value={rackRateLoanType}
        label="Select a loan type"
        options={loanTypeOptions}
        setValue={setRackRateLoanType}
      />
    </div>
  );
}

function Toggle({ value, label, options = [], maxWidth, setValue }) {
  const [option1 = {}, option2 = {}] = options;
  const labelId = useMemo(() => uniqueId('label-'), []);

  return options?.length < 2 ? null : (
    <div
      style={{ maxWidth }}
      className={styles.item}
    >
      {label && (
        <label
          id={labelId}
          className={styles.label}
        >
          {label}
        </label>
      )}
      <div
        className={styles.toggle}
        role="group"
        aria-labelledby={label ? labelId : null}
      >
        <div className={styles.toggleBgWrapper}>
          <div
            className={classNames(styles.toggleBg, {
              [styles.right]: value !== option1.value
            })}
          />
        </div>

        <button
          type="button"
          name={option1.label}
          className={classNames(styles.button, {
            [styles.active]: value === option1.value
          })}
          aria-pressed={option1.value === value}
          onClick={() => setValue(option1.value)}
        >
          <span>{option1.label}</span>
        </button>

        <button
          type="button"
          name={option2.label}
          className={classNames(styles.button, {
            [styles.active]: value === option2.value
          })}
          aria-pressed={option2.value === value}
          onClick={() => setValue(option2.value)}
        >
          <span>{option2.label}</span>
        </button>
      </div>
    </div>
  );
}
